import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import "./Intro.css";

// ─── コンポーネント外に定数を移動（毎レンダーの再生成を防ぐ）────────
const TEXT = "Forge the Future";
const LETTERS = TEXT.split("");

const Intro = () => {
  const logoRef = useRef(null);
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power1.inOut" } });

    // 背景フェードイン
    tl.from(containerRef.current, { opacity: 0, duration: 0 });

    // ロゴフェードイン
    tl.from(logoRef.current, { opacity: 0, duration: 1.5 }, "-=0.5");

    // 文字を順番にフェードイン
    tl.fromTo(
      textRef.current.querySelectorAll("span"),
      { opacity: 0, y: -20 },
      { opacity: 1, y: 0, duration: 0.1, stagger: 0.05 },
      "-=1"
    );

    // ロゴフワッと光るループ
    tl.to(
      logoRef.current,
      {
        filter:
          "drop-shadow(0 0 5px rgba(255,255,255,0.7)) drop-shadow(0 0 10px rgba(255,255,255,0.5))",
        duration: 1.2,
        repeat: 1,
        yoyo: true,
      },
      "-=1"
    );

    // 2秒静止
    tl.to({}, { duration: 1 });

    // フェードアウト
    tl.to(containerRef.current, { opacity: 0, duration: 1 });

    // Home へ遷移（履歴を置き換えてイントロに戻れないようにする）
    tl.call(() => navigate("/home", { replace: true }));

    // クリーンアップ：アンマウント時にアニメーションを破棄
    return () => tl.kill();
  }, [navigate]);

  return (
    <div className="intro-page" ref={containerRef}>
      <img
        src="/logo.svg"
        alt="Company Logo"
        ref={logoRef}
        className="intro-logo"
      />
      <div className="intro-text-overlay">
        <p className="intro-text" ref={textRef}>
          {LETTERS.map((letter, index) =>
            letter === " " ? (
              // スペースは .intro-text-space クラスで管理
              <span key={`letter-${index}`} className="intro-text-space">
                &nbsp;
              </span>
            ) : (
              <span key={`letter-${index}`}>{letter}</span>
            )
          )}
        </p>
      </div>
    </div>
  );
};

export default Intro;